import React from "react";
import PropTypes from "prop-types";
import { Modal } from "arv-reactcomponents";
import PdpFitGuide from "../PdpComponents/PdpFitGuide";

const FitGuidePrompt = props => {
  const {
    className,
    preventfix,
    showFitGuideModal,
    closeFitGuideModal,
    brandName,
    name,
    sizeChartId,
    sizeRecommendation,
  } = props;
  return (
    <Modal
      isOpen={showFitGuideModal}
      preventfix={preventfix}
      onClose={closeFitGuideModal}
    >
      <PdpFitGuide.component
        className={`nw-pdp-modalsize ${className}`}
        brandName={brandName}
        productTitle={name}
        sizeChartId={sizeChartId}
        sizeRecommendation={sizeRecommendation}
      />
    </Modal>
  );
};

FitGuidePrompt.defaultProps = {
  className: "",
  ProductLoader: false,
  sizeChartId: "",
  preventfix: false,
  sizeRecommendation: "",
};

FitGuidePrompt.propTypes = {
  className: PropTypes.string,
  showFitGuideModal: PropTypes.bool.isRequired,
  closeFitGuideModal: PropTypes.func.isRequired,
  brandName: PropTypes.string,
  ProductLoader: PropTypes.bool,
  preventfix: PropTypes.bool,
  fitGuideModal: PropTypes.func,
  sizeChartId: PropTypes.string,
  sizeRecommendation: PropTypes.string,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: FitGuidePrompt,
  component: FitGuidePrompt,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/FitGuidePrompt/index.js